import React, { useMemo } from 'react';
import { Text } from '@atlaskit/primitives';

export const CreateCustomerHeader = ({ currentStage }: { currentStage: number }) => {
  const title = useMemo(() => {
    if (currentStage === 0) {
      return 'Company name';
    }
    if (currentStage === 1) {
      return 'Company address';
    }
    if (currentStage === 2) {
      return 'Finalise';
    }
  }, [currentStage]);

  return (
    <Text weight="semibold" id="create-customer-header">
      {currentStage + 1}: {title}
    </Text>
  );
};
